import { LoggedOutBlueWaveTemplateJsm } from '../components/logged-out-blue-wave-template-jsm';

import { useIntl } from 'react-intl';

export const LoggedOutJsmStandard = () => {
	const { formatMessage } = useIntl();

	return (
		<LoggedOutBlueWaveTemplateJsm
			productEditionText={formatMessage({
				id: 'WacSignupHeader.cloudStandard',
				defaultMessage: 'Cloud Standard',
			})}
		/>
	);
};
